"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChatParticipantsNames = exports.getChatName = void 0;
var getChatName = exports.getChatName = function getChatName(chat, unknownUserTranslation) {
  if (!chat || !chat.participants) {
    return unknownUserTranslation;
  }
  if (chat.participants.length === 0) {
    return unknownUserTranslation;
  }
  if (chat.participants.length === 1) {
    return getPartipantLastNameFirstName(chat.participants[0], unknownUserTranslation);
  }
  if (chat.name && chat.name.length > 0) {
    return chat.name;
  }
  return chat.participants.map(function (p) {
    return getPartipantFirstName(p, unknownUserTranslation);
  }).sort(function (a, b) {
    return compareParticipants(a, b, unknownUserTranslation);
  }).join(', ');
};
var getChatParticipantsNames = exports.getChatParticipantsNames = function getChatParticipantsNames(chat, unknownUserTranslation) {
  if (!chat || !chat.participants) {
    return [];
  }
  return chat.participants.map(function (p) {
    return {
      displayName: getPartipantLastNameFirstName(p, unknownUserTranslation),
      id: p.id
    };
  }).sort(function (a, b) {
    return compareParticipants(a.displayName, b.displayName, unknownUserTranslation);
  });
};
var compareParticipants = function compareParticipants(s1, s2, unknownUserTranslation) {
  if (s1 === unknownUserTranslation && s2 === unknownUserTranslation) {
    return 0;
  }
  if (s1 === unknownUserTranslation) {
    return 1;
  }
  if (s2 === unknownUserTranslation) {
    return -1;
  }
  if (s1 < s2) {
    return -1;
  }
  if (s1 > s2) {
    return 1;
  }
  return 0;
};
var getPartipantLastNameFirstName = function getPartipantLastNameFirstName(participant, unknownUserTranslation) {
  if (participant.hasError === true) {
    return unknownUserTranslation;
  }
  if (participant.firstname && participant.lastname) {
    return "".concat(participant.lastname, ", ").concat(participant.firstname);
  }
  if (participant.firstname) {
    return participant.firstname;
  }
  if (participant.lastname) {
    return participant.lastname;
  }
  return unknownUserTranslation;
};
var getPartipantFirstName = function getPartipantFirstName(participant, unknownUserTranslation) {
  if (participant.hasError === true) {
    return unknownUserTranslation;
  }
  if (participant.firstname) {
    return participant.firstname;
  }
  if (participant.lastname) {
    return participant.lastname;
  }
  return unknownUserTranslation;
};